
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/store/types";
import api from "@/services/api.service";

@Component({})
export default class AreaSchedule extends Vue {
	@Prop({ required: true, type: Number, default: 0 }) areaId;

	@Getter getPermissions: UserPermissions;

	public schedule = null;

	async mounted() {
		if (this.areaId > 0) {
			this.schedule = await api.getWeeklyDisarmSchedule(this.areaId);
		}
	}

	private userHasPermission() {
		return this.getPermissions.canViewSiteSetup || this.getPermissions.canHandleAlarms;
	}

	private getDisarmPeriodStyling(period) {
		return {
			left: period.startPoint + "%",
			width: period.endPoint - period.startPoint + "%"
		};
	}
}
